import { getLuminance } from 'polished';
import { DEFAULT_BRANDING_COLOR, HUB_PRIMARY_COLOR_CSS_VAR, HUB_PRIMARY_TEXT_COLOR_CSS_VAR } from '../../constants';
var readableTextColor = function readableTextColor(color) {
  return getLuminance(color) > 0.5 ? "var(--ds-text, #172B4D)" : "var(--ds-text-inverse, #FFFFFF)";
};
export var setHubBrandingStyle = function setHubBrandingStyle(_ref) {
  var primaryColor = _ref.primaryColor,
    targetElement = _ref.targetElement;
  var primaryColorToUse = primaryColor || DEFAULT_BRANDING_COLOR;
  var primaryTextColor = readableTextColor(primaryColorToUse);
  if (!targetElement) {
    return;
  }
  targetElement.style.setProperty(HUB_PRIMARY_COLOR_CSS_VAR, primaryColorToUse);
  targetElement.style.setProperty(HUB_PRIMARY_TEXT_COLOR_CSS_VAR, primaryTextColor);
  return function () {
    targetElement.style.removeProperty(HUB_PRIMARY_COLOR_CSS_VAR);
    targetElement.style.removeProperty(HUB_PRIMARY_TEXT_COLOR_CSS_VAR);
  };
};